import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';
import { PAXES_CHILDREN_TYPE, getLabelValueOptionsList } from '../../commons/utils';

import Service from './Service';
import { getServiceFromListByCode } from './utils';

const ListContainer = (props) => {
  const {
    roomId,
    distribution,
    servicesList,
    availableServicesList,
    readOnly
  } = props;

  const [finalServicesList, setFinalServicesList] = useState([]);

  useEffect(() => {
    if (availableServicesList.length === 0 && servicesList.length === 0) {
      setFinalServicesList([]);
      return;
    }

    let combinedServicesList = [];

    availableServicesList.forEach((service) => {
      const { id } = service;

      const existingService = servicesList.find(service => service.id === id);

      if(existingService) {
        combinedServicesList.push({...service, ...existingService, isSelected: true});
      } else if(!readOnly) {
        combinedServicesList.push({...service, isSelected: false});
      }
    });

    const erroneousServices = servicesList.filter((service) => !getServiceFromListByCode(service.id, availableServicesList));
    if (erroneousServices && erroneousServices.length > 0) {
      erroneousServices.forEach((service) => {
        combinedServicesList.push({...service, name: service.code, error: true});
      });
    }

    setFinalServicesList(combinedServicesList);

  }, [props.availableServicesList, props.servicesList]); // eslint-disable-line react-hooks/exhaustive-deps

  const getServiceProps = (service) => {
    const {
      paxType,
      datesList,
      date,
      quantity,
      isSelected
    } = service;

    const { adults, children } = distribution;

    const avilablePaxes = (paxType === PAXES_CHILDREN_TYPE) ? children : adults;

    let defaultDate = '';
    if (datesList && datesList[0] && datesList[0].value) {
      defaultDate = datesList[0].value;
    }

    return {
      selectedPaxes: (quantity !== undefined) ? quantity : 1,
      selectedDate: (date !== undefined) ? date : defaultDate,
      isSelected,
      availableDates: (datesList) ? datesList : [],
      availablePaxes: getLabelValueOptionsList(avilablePaxes, false),
      wrongData: (service.error !== undefined) ? service.error : false
    };
  };

  const handleNewService = (service) => {
    props.handleNewService(roomId, service);
  };

  const handleDeleteService = (serviceId) => {
    props.handleDeleteService(roomId, serviceId);
  };

  const handleUpdateService = (serviceData) => {
    props.handleUpdateService(roomId, serviceData);
  };

  return (
    <Row className="services-list__container">
      {(!finalServicesList || finalServicesList.length === 0)
        ?
          <label className="no-data">{translate('no_servicios')}</label>
        :
          finalServicesList.map((service, index) => {
            const serviceKey = `ROOM-${roomId}-SERVICE-${index}`;

            const { id, code, name } = service;

            return (
              <Col key={serviceKey} sm="4" className="service__container">
                <Service
                  id={id}
                  code={code}
                  name={name}
                  {...getServiceProps(service)}
                  readOnly={readOnly}
                  addServiceAction={handleNewService}
                  removeServiceAction={handleDeleteService}
                  updateServiceAction={handleUpdateService}
                />
              </Col>
            )
          })
      }
    </Row>
  );
};

ListContainer.propTypes = {
  roomId: PropTypes.number.isRequired,
  distribution: PropTypes.shape({
    adults: PropTypes.number,
    children: PropTypes.number
  }).isRequired,
  availableServicesList: PropTypes.arrayOf(PropTypes.object),
  servicesList: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  handleNewService: PropTypes.func,
  handleDeleteService: PropTypes.func,
  handleUpdateService: PropTypes.func,
};

ListContainer.defaultProps = {
  availableServicesList: [],
  servicesList: [],
  readOnly: false,
  handleNewService: () => {},
  handleDeleteService: () => {},
  handleUpdateService: () => {}
};

export default ListContainer;
